import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import config from 'config';
import './App.css';
import Header from '../_components/header';
import Footer from '../_components/footer';
import { PrivateRoute } from '../_components';
import { LoginPage } from '../LoginPage';
import { BookingPage } from '../BookingPage';
import { JobPage } from '../JobPage';
import { QueryPage } from '../QueryPage';
import { InvoicePage } from '../InvoicePage';
import { UserPage } from '../UserPage';
import { UsersPage } from '../UsersPage';
import { UserPreferencesPage } from '../UserPreferencesPage';
import { FrequentAddressPage } from '../FrequentAddressPage';
import { FrequentAddressQueryPage } from '../FrequentAddressQueryPage';
import { BookingOptionsPage } from '../BookingOptionsPage';
import { BookingReferencePage } from '../BookingReferencePage';
import { BookingReferenceQueryPage } from '../BookingReferenceQueryPage';
import { ChangePasswordPage } from '../ChangePasswordPage';
import { PasswordChangedPage } from '../PasswordChangedPage';
import { RecoverPage } from '../RecoverPage';
import { NotFoundPage } from '../NotFoundPage';
import { ErrorPage } from '../ErrorPage';
import WelcomePage from '../WelcomePage/WelcomePage';

function App(props) {
    return (
        <div>
            <Header/>
            <Router basename={config.basename}>
                <div>
                <Routes>
                    <Route path="/" element={<PrivateRoute><BookingPage/></PrivateRoute>} />
                    <Route path="/Welcome" element={<PrivateRoute><WelcomePage /></PrivateRoute>} />
                    <Route path="/query" element={<PrivateRoute><QueryPage /></PrivateRoute>} />
                    <Route path="/job" element={<PrivateRoute><JobPage /></PrivateRoute>} />
                    <Route path="/invoices" element={<PrivateRoute><InvoicePage /></PrivateRoute>} />
                    <Route path="/user" element={<PrivateRoute><UserPage /></PrivateRoute>} />
                    <Route path="/user_preferences" element={<PrivateRoute><UserPreferencesPage /></PrivateRoute>} />
                    <Route path="/frequent_address" element={<PrivateRoute><FrequentAddressPage /></PrivateRoute>} />
                    <Route path="/booking_reference" element={<PrivateRoute><BookingReferencePage /></PrivateRoute>} />
                    <Route path="/admin_users" element={<PrivateRoute><UsersPage /></PrivateRoute>} />
                    <Route path="/admin_addresses" element={<PrivateRoute><FrequentAddressQueryPage /></PrivateRoute>} />
                    <Route path="/admin_booking_options" element={<PrivateRoute><BookingOptionsPage /></PrivateRoute>} />
                    <Route path="/admin_booking_references" element={<PrivateRoute><BookingReferenceQueryPage /></PrivateRoute>} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/change_password" element={<PrivateRoute><ChangePasswordPage /></PrivateRoute>} />
                    <Route path="/password_changed" element={<PrivateRoute><PasswordChangedPage /></PrivateRoute>} />
                    <Route path="/recover" element={<RecoverPage />} />
                    <Route path="/error" element={<ErrorPage />} />
                    <Route path="*" exact={true} element={<NotFoundPage />} />
                </Routes>
                </div>
            </Router>
            <Footer/>
        </div>
    );
}

export { App }; 